import {useParams} from "react-router-dom";
import {useGetATransaction} from "../../../core/services/react-query/report/transactions";
import ObjectView from "../../../components/common/utils/ObjectView";
import {Flex} from "../../../styles/CommonStyles";
import {useMainContext} from "../../../core/contexts/main";


const TransactionDetails = () => {

    const { theme } = useMainContext()
    const params = useParams()
    const id = params.id

    const { data: transaction } = useGetATransaction(id)

    return (
        <Flex fw height={'100vh'}>
            <ObjectView obj={transaction} theme={theme} />
        </Flex>
    )
}

export default TransactionDetails
